export const getSrc = path => {
  return process.env.REACT_APP_ELECTRON === 'true' ? `${process.env.REACT_APP_ELECTRON_STATIC_FILES}${path}` : path
}



// WEBPACK FOOTER //
// ./src/utils/image.js